import { LoadableApp } from 'ui-seeker/core'
import { VR_DESTINATION, VR_COMPETENCE, VR_RAW, VR_ADMIN } from 'app/config'

const Destination = LoadableApp(import('./Destination'))
const Competence = LoadableApp(import('./Competence'))
const Raw = LoadableApp(import('./Raw'))
const Admin = LoadableApp(import('./Admin'))

const PageRoutes = [
    { path: VR_DESTINATION.path, component: Destination, needLogin: true },
    { path: VR_COMPETENCE.path, component: Competence, needLogin: true },
    { path: VR_RAW.path, component: Raw, needLogin: true },
    { path: VR_ADMIN.path, component: Admin, needLogin: true }
]

export default PageRoutes